export const isAttendanceFeatureEnabled = () =>
  process.env.REACT_APP_FEATURE_ATTENDANCE === 'true';

export const isAdvisorMidSemesterConfirmEnabled = () =>
  process.env.REACT_APP_FEATURE_ADVISOR_MIDSEMESTER_CONFIRM === 'true';
